import React from "react";
import PropTypes from "prop-types";
//Material imports
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
// Limitless imports
import { useTranslation, useAppConfig } from "@limitless/common/hooks";
import { PortalTextInput, LoginButton, LocaleFlagAutoComplete, TermsDialog, PrivacyInfo } from "@limitless/portal";
import { groupSignUpPageStyles } from "../styles/groupSignup";
import Towns from "../Towns";
const INITIAL_STATE = {
  showOnlyPrivacy: false,
  backToTerms: true
};
const SignUpForm = ({
  stateCtx
}) => {
  var _values$country$value, _values$country, _values$country$value2, _values$country$value3;
  const classes = groupSignUpPageStyles();
  const {
    t
  } = useTranslation();
  const {
    getContactUsUrl
  } = useAppConfig();
  const [isLoading, setIsLoading] = React.useState(false);
  const [termsState, setTermsState] = React.useState(INITIAL_STATE);
  const {
    submitHandler,
    values,
    setLoading,
    handleStateChange,
    disableTermsStyle,
    fieldErrors,
    isFormInvalid,
    showPassword,
    setShowPassword,
    termsDialogOpen,
    towns,
    handleTownChange,
    handleCountryChange,
    setTermsDialogOpen
  } = stateCtx;
  const handleTermsClick = () => {
    if (disableTermsStyle) {
      handleStateChange({
        termsOfService: false
      });
    } else {
      setTermsDialogOpen(true);
    }
  };
  const termsStyling = disabled => {
    return disabled ? `${classes.termsText} ${classes.termsTextDisabled}` : `${classes.termsText}`;
  };
  const handleContactUsClick = () => {
    const url = getContactUsUrl();
    window.open(url, "_blank");
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    component: Typography,
    variant: "h2",
    color: "textPrimary"
  }, t("Create Account")), /*#__PURE__*/React.createElement(Grid, {
    className: classes.signUpForm
  }, /*#__PURE__*/React.createElement(Grid, {
    className: classes.email
  }, /*#__PURE__*/React.createElement(PortalTextInput, {
    id: "emailInput",
    label: t("Email Address"),
    onChange: event => handleStateChange({
      email: event.target.value
    }),
    value: values.email.value,
    placeholder: t("Email Address"),
    isMandatory: true,
    InputProps: {
      className: classes.input
    },
    error: fieldErrors.email ? true : false,
    helperText: fieldErrors.email
  })), /*#__PURE__*/React.createElement(Grid, {
    className: classes.password
  }, /*#__PURE__*/React.createElement(PortalTextInput, {
    id: "passwordInput",
    label: t("Password"),
    helperText: !values.password.pristine && fieldErrors.oldPassword,
    error: !values.password.pristine && isFormInvalid,
    onChange: event => handleStateChange({
      password: event.target.value
    }),
    value: values.password.value,
    placeholder: t("Password"),
    isMandatory: true,
    type: showPassword ? "text" : "password",
    InputProps: {
      className: classes.input,
      endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        background: "f4f4f4",
        position: "end"
      }, /*#__PURE__*/React.createElement(IconButton, {
        "aria-label": "toggle password visibility",
        onClick: () => setShowPassword(!showPassword),
        size: "large"
      }, showPassword ? /*#__PURE__*/React.createElement(Visibility, null) : /*#__PURE__*/React.createElement(VisibilityOff, null)))
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    className: classes.firstName
  }, /*#__PURE__*/React.createElement(PortalTextInput, {
    id: "firstName",
    label: t("First Name"),
    onChange: event => {
      var _event$target;
      return handleStateChange({
        firstName: event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value
      });
    },
    value: values.firstName.value,
    placeholder: t("First Name"),
    fullWidth: true,
    isMandatory: true,
    InputProps: {
      className: classes.input
    },
    error: fieldErrors.firstName ? true : false,
    helperText: fieldErrors.firstName
  })), /*#__PURE__*/React.createElement(Grid, {
    className: classes.lastName
  }, /*#__PURE__*/React.createElement(PortalTextInput, {
    id: "lastName",
    label: t("Last Name"),
    textInputClasses: {
      notchedOutline: classes.noBorder
    },
    onChange: event => {
      var _event$target2;
      return handleStateChange({
        lastName: event === null || event === void 0 ? void 0 : (_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : _event$target2.value
      });
    },
    value: values.lastName.value,
    placeholder: t("Last Name"),
    fullWidth: true,
    isMandatory: true,
    InputProps: {
      className: classes.input
    },
    error: fieldErrors.lastName ? true : false,
    helperText: fieldErrors.lastName
  })), /*#__PURE__*/React.createElement(Grid, {
    className: classes.country
  }, /*#__PURE__*/React.createElement(LocaleFlagAutoComplete, {
    label: t("Country of Residence"),
    placeholder: t("Country"),
    selectedLocale: values.country.value,
    onValueChange: handleCountryChange,
    disabled: false,
    onlyCountry: false,
    isMandatory: true,
    classes: {
      root: classes.autoCompleteRoot
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    style: {
      marginTop: -15
    },
    className: classes.countryCaption
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    color: "textPrimary"
  }, t("Your country of residence will be verified as part of our registration process."))), /*#__PURE__*/React.createElement(Towns, {
    towns: towns,
    classes: classes,
    onTownChange: handleTownChange,
    selectedTown: values.town.value,
    locale: (_values$country$value = values.country.value) === null || _values$country$value === void 0 ? void 0 : _values$country$value.value
  }), /*#__PURE__*/React.createElement(Grid, {
    className: classes.termsContainer
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    alignItems: "center",
    className: classes.termsTextContainer
  }, /*#__PURE__*/React.createElement(Checkbox, {
    name: "terms",
    color: "primary",
    id: "termsCheckbox",
    checked: values.termsOfService.value,
    onClick: () => {
      if (!values.termsOfService.value) {
        return handleTermsClick();
      }
      return handleStateChange({
        termsOfService: false
      });
    },
    value: `${values.termsOfService.value}`,
    disabled: !((_values$country = values.country) !== null && _values$country !== void 0 && (_values$country$value2 = _values$country.value) !== null && _values$country$value2 !== void 0 && _values$country$value2.value)
  }), /*#__PURE__*/React.createElement(Typography, {
    style: {
      maxWidth: "80%"
    },
    onClick: handleTermsClick,
    className: termsStyling(disableTermsStyle),
    id: "termsButton",
    color: "textPrimary"
  }, t("I have read and agree to the Terms of Services and Code of Conduct")), /*#__PURE__*/React.createElement(TermsDialog, {
    backToTerms: termsState.backToTerms,
    showOnlyPrivacy: termsState.showOnlyPrivacy,
    open: termsDialogOpen,
    onClose: () => {
      setTermsDialogOpen(false);
      setTermsState({
        ...INITIAL_STATE
      });
    },
    locale: (_values$country$value3 = values.country.value) === null || _values$country$value3 === void 0 ? void 0 : _values$country$value3.value,
    acceptTerms: () => {
      handleStateChange({
        termsOfService: true
      });
    }
  })), /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement("div", {
    className: classes.singleTerm
  }, /*#__PURE__*/React.createElement(Checkbox, {
    name: "terms",
    color: "primary",
    id: "termsCheckbox",
    checked: values.ageTerms.value,
    onClick: () => handleStateChange({
      ageTerms: !values.ageTerms.value
    }),
    value: `${false}`,
    disabled: false
  }), /*#__PURE__*/React.createElement(Typography, {
    id: "onboardAgeTermsButton",
    color: "textPrimary",
    className: classes.termsText,
    onClick: () => handleStateChange({
      ageTerms: !values.ageTerms.value
    })
  }, t("I confirm that I am over 18 years of age")))), /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement("div", {
    className: classes.singleTerm
  }, /*#__PURE__*/React.createElement(Checkbox, {
    name: "newsLetter",
    color: "primary",
    id: "newLetterCheckbox",
    checked: values.newsLetter.value,
    onClick: () => {
      handleStateChange({
        newsLetter: !values.newsLetter.value
      });
    },
    value: `${false}`,
    disabled: false
  }), /*#__PURE__*/React.createElement(Typography, {
    color: "textPrimary",
    id: "onboardNewsLetterTermsButton",
    className: classes.termsText,
    onClick: () => {
      handleStateChange({
        newsLetter: !values.newsLetter.value
      });
    }
  }, t("I would like to sign up to the newsletter (optional)"))), /*#__PURE__*/React.createElement(Grid, {
    className: classes.signUpButton,
    container: true,
    direction: "row"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(LoginButton, {
    style: {
      marginTop: 20,
      marginBottom: 10,
      minWidth: 300
    },
    loading: isLoading,
    component: "button",
    disabled: isFormInvalid,
    id: "startEarningNowButton2",
    onClick: async () => {
      setLoading(true);
      await submitHandler(setIsLoading);
    }
  }, "Sign Up")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.privacyInfo
  }, /*#__PURE__*/React.createElement(PrivacyInfo, {
    text: "See how we handle your data in our",
    triggerPrivacyOverlay: () => {
      setTermsState({
        showOnlyPrivacy: true,
        backToTerms: false
      });
      setTermsDialogOpen(true);
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    display: "flex",
    mb: 5
  }, /*#__PURE__*/React.createElement(Typography, null, t("Having trouble in sign up?")), /*#__PURE__*/React.createElement(Typography, {
    color: "primary",
    style: {
      cursor: "pointer",
      paddingLeft: 2
    },
    onClick: handleContactUsClick
  }, t("Contact Us"))))))));
};
export default SignUpForm;
SignUpForm.propTypes = {
  stateCtx: PropTypes.object.isRequired
};